import { useCallback } from 'react';

import isFunction from 'utils/function';
import { isWeb } from 'utils/responsiveness';

type Props = {
    setModalOpen: (value: boolean) => void;
    onOpenOperation?: () => void;
    onCloseOperation?: () => void;
    onWebCloseOperation?: () => void;
};

export default function useModalHandler({
    setModalOpen,
    onOpenOperation,
    onCloseOperation,
    onWebCloseOperation,
}: Props) {
    const onCloseModalWebBackButton = useCallback(() => {
        setModalOpen(false);

        if (isFunction(onWebCloseOperation)) {
            onWebCloseOperation();
        }

        if (isWeb) {
            window.removeEventListener('popstate', onCloseModalWebBackButton);
        }
    }, [onWebCloseOperation]);

    const onOpenModal = useCallback(() => {
        if (isFunction(onOpenOperation)) {
            onOpenOperation();
        }

        setModalOpen(true);

        if (isWeb) {
            window.history.pushState({}, '', null);
            window.addEventListener('popstate', onCloseModalWebBackButton);
        }
    }, [onOpenOperation, onWebCloseOperation]);

    const onCloseModal = useCallback(() => {
        setModalOpen(false);

        if (isFunction(onCloseOperation)) {
            onCloseOperation();
        }

        if (isWeb) {
            window.history.back();
        }
    }, [onCloseOperation]);

    return { onOpenModal, onCloseModal };
}
